import { type IResponseEventMessage } from 'entities/Message'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useEventMessageReceivedNewGlobal } from 'entities/Conversation/events/EventMessageReceivedNewGlobal'
import { type CallHistoryStore } from 'pages/conversations/pages/calls/ui/CallHistory'

export const useEventMessageReceivedNew = (callHistoryStore: CallHistoryStore) => {
  const { inboxesStore } = useEntitiesContext()
  const handler = (data: IResponseEventMessage) => {
    const { call_history, conversation } = data
    if (!call_history || inboxesStore.currentInboxTypeId !== conversation.inbox_id) return

    const { type, outcome } = call_history.call

    if (type && outcome) {
      callHistoryStore.updateCallHistoryByMessageReceivedEvent(call_history)
    }
  }

  useEventMessageReceivedNewGlobal(handler)
}
